module.exports = __webpack_public_path__ + "static/media/aragonQuest.cf7e7366.png";